import EnergyConsumptionFlexeservePanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/EnergyConsumptionFlexeserve/EnergyConsumptionFlexeservePanel';
import React from 'react';
import LabelValuePanel from '../LabelValuePanel/LabelValuePanel';
import { IAnyPanel } from '../Dashboard.model';
import TrendPanel from '../TrendPanel/TrendPanel';
import PieChartPanel from '../PieChartPanel/PieChartPanel';
import GaugePanel from '../GaugePanel/GaugePanel';
import BarChartPanel from '../BarChartPanel/BarChartPanel';
import DataGridPanel from '../DataGridPanel/DataGridPanel';
import AlarmGroupPanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/AlarmPanel/AlarmGroupPanel';
import AlarmWorkspacePanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/AlarmPanel/AlarmWorkspacePanel';
import StorePanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/Stores/StorePanel';
import { LayoutItem } from 'react-grid-layout';
import LowTempPanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/LowTemp/LowTempPanel';
import GatewayErrorPanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/GatewayError/GatewayErrorPanel';
import FlexeserveDeviceErrorPanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/FlexeserveDeviceError/FlexeserveDeviceErrorPanel';
import SmartSwitchDeviceErrorPanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/SmartSwitchDeviceError/SmartSwitchDeviceErrorPanel';
import CommanderOfflinePanel from '../../../../pages/AuthenticatedPages/Manager/ManagerViewLocations/EntityBusinessLayerList/EntityDashboard/panels/CommanderOffline/CommanderOfflinePanel';

interface PanelSelectorProps {
  panel: IAnyPanel;
  layout?: LayoutItem | undefined;
}
function PanelSelector(props: PanelSelectorProps) {
  const { panel } = props;
  switch (panel.type) {
    case 'LABEL_VALUE':
      return <LabelValuePanel panel={panel} layout={props.layout} />;
    case 'TREND':
      return <TrendPanel panel={panel} layout={props.layout} />;
    case 'PIE_CHART':
      return <PieChartPanel panel={panel} layout={props.layout} />;
    case 'GAUGE':
      return <GaugePanel panel={panel} layout={props.layout} />;
    case 'BAR_CHART':
      return <BarChartPanel panel={panel} layout={props.layout} />;
    case 'DATA_GRID':
      return <DataGridPanel panel={panel} layout={props.layout} />;
    case 'GROUP_ALARMS':
      return <AlarmGroupPanel panel={panel} />;
    case 'WORKSPACE_ALARMS':
      return <AlarmWorkspacePanel panel={panel} />;
    case 'STORES':
      return <StorePanel panel={panel} layout={props.layout} />;
    case 'COMMANDER_OFFLINE':
      return <CommanderOfflinePanel panel={panel} layout={props.layout} />;
    case 'LOW_TEMP':
      return <LowTempPanel panel={panel} layout={props.layout} />;
    case 'GATEWAY_ERROR':
      return <GatewayErrorPanel panel={panel} layout={props.layout} />;
    case 'FLEXESERVE_DEVICE_ERROR':
      return <FlexeserveDeviceErrorPanel panel={panel} layout={props.layout} />;
    case 'SMART_SWITCH_DEVICE_ERROR':
      return (
        <SmartSwitchDeviceErrorPanel panel={panel} layout={props.layout} />
      );
    case 'ENERGY_CONSUMPTION_FLEXESERVE':
      return (
        <EnergyConsumptionFlexeservePanel panel={panel} layout={props.layout} />
      );
    default:
      return <div>Unknown panel type</div>;
  }
}

export default PanelSelector;
